export default "__VITE_PUBLIC_ASSET__7d955694__"